import type { HeadNavMenuConst } from '@/constant/headNavigationMenu'
import mittBus from '@/utils/mitt'

type Emit = (event: 'clickLogin' | 'logout', ...args: any[]) => void

export const useLogout = () => {
  const loginMenuVisible = ref(false)

  /** 悬浮进入头像 */
  const hoverEnterAvatar = () => {
    if (loginMenuVisible.value) return
    loginMenuVisible.value = true
  }

  /** 悬浮离开头像 */
  const hoverLeaveAvatar = () => closeLoginMenu()

  /** 关闭登录菜单 */
  const closeLoginMenu = () => {
    if (!loginMenuVisible.value) return
    loginMenuVisible.value = false
  }
  /** 准备退出登录 */
  const toLogout = (emit: Emit) => {
    closeLoginMenu()
    emit('logout')
  }

  return {
    loginMenuVisible,
    hoverEnterAvatar,
    hoverLeaveAvatar,
    closeLoginMenu,
    toLogout
  }
}

export const useCursor = () => {
  const CURSOR_WIDTH = 40
  const route = useRoute()

  const cursorStyle = reactive({ width: `${CURSOR_WIDTH}px`, left: -1000 })
  const activatedMainMenuItem = ref<`${HeadNavMenuConst}`>('home')

  /**
   * 是否命中管理中心模块的方法
   */
  const isMatched = (routeName: string) => {
    const controlCenterRouteNameSet = new Set([
      'certificationReview',
      'certification',
      'accountInfo',
      'subAccountInfo',
      'subAccountManagement',
      'authenticationInfo',
      'ipWhitelist',
      'gameManagementMainEntance',
      'reservationMaterial',
      'toPerfectInfo',
      'toUpdateInfo',
      'toCheckInfo',
      'x7ShopManagement',
      'x7ShopTypeDetail',
      'settlementCenterMainEntance',
      'dataCenterMainEntance',
      'exchangeRateRecord',
      'gameReview',
      'gameTest',
      'giftManagement'
    ])
    return controlCenterRouteNameSet.has(routeName)
  }

  /** 设置光标的偏移量 */
  const setOffsetLeft = () => {
    const targetEleId = activatedMainMenuItem.value
    const ele = document.getElementById(targetEleId) as HTMLElement
    if (!ele) {
      const { clientWidth, offsetLeft } = (document.getElementById('home') as HTMLElement) ?? {}
      const leftOffset = Math.ceil(offsetLeft + clientWidth / 2 - CURSOR_WIDTH / 2)
      Object.assign(cursorStyle, { left: `${leftOffset}px` })
      return
    }
    const { clientWidth, offsetLeft } = ele
    const leftOffset = Math.ceil(offsetLeft + clientWidth / 2 - CURSOR_WIDTH / 2)
    Object.assign(cursorStyle, { left: `${leftOffset}px` })
  }

  /**
   * 自动更新光标
   */
  const updateCursor = () => {
    let name = route.name as `${HeadNavMenuConst}`
    if (isMatched(name)) name = 'controlCenter'
    activatedMainMenuItem.value = name
    nextTick(setOffsetLeft)
  }

  mittBus.on('routeChange', updateCursor)
  onMounted(() => {
    updateCursor()
  })
  onUnmounted(() => {
    mittBus.off('routeChange', updateCursor)
  })

  return { cursorStyle, activatedMainMenuItem }
}

export const useTransparentTheme = () => {
  const route = useRoute()
  const router = useRouter()
  const isTransparentTheme = ref(true) // 默认是透明主题

  /**
   * 切换主题
   */
  const switchTheme = () => {
    if (route.name === 'home') isTransparentTheme.value = window.scrollY === 0
  }

  router.afterEach((to) => (isTransparentTheme.value = to.name === 'home'))

  mittBus.on('windowScroll', switchTheme)
  onUnmounted(() => {
    mittBus.off('windowScroll', switchTheme)
  })

  return { isTransparentTheme }
}
